import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatistics, StoreState } from '../../store/reducers';

import './dashboard-page.css';


const DashboardPage = () => {

    const appClient = useSelector((state: StoreState) => state.currentAppClient);

    // reload statistics whenever the page is reloaded
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchStatistics(appClient));
    }, [dispatch, appClient]);

    return (
        <>
            <div>Dashboard</div>
        </>
    );
}

export default DashboardPage;
